import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Fade,
  Backdrop,
} from "@mui/material";
import saveCartRecord from "../../services/SaveCartRecord.js";

export default function SaveCartRecordModal({
  open,
  onClose,
  cartNumber,
  relevantUrl,
}) {
  const [recordName, setRecordName] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // "success" | "error" | null

  const handleClose = () => {
    if (!loading) {
      setStatus(null);
      setRecordName("");
      onClose?.();
    }
  };

  async function handleSave() {
    const name = recordName.trim();
    if (!name) return;
    setLoading(true);
    setStatus(null);

    try {
      console.log("Saving cart record:", cartNumber, relevantUrl, name);
      const response = await saveCartRecord(cartNumber, relevantUrl, name);
      console.log(response);

      if (response === "ok") {
        setStatus("success");
        setRecordName("");
      } else {
        setStatus("error");
        console.error("Error saving cart record:", response);
      }
    } catch (err) {
      console.error("Error saving cart record:", err);
      setStatus("error");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      aria-labelledby="save-record-modal-title"
      aria-describedby="save-record-modal-description"
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 300 } }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 360,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            outline: "none",
          }}
        >
          <Typography id="save-record-modal-title" variant="h6" textAlign="center">
            Save Cart Record
          </Typography>

          <Typography
            id="save-record-modal-description"
            variant="body2"
            color="text.secondary"
            textAlign="center"
          >
            This saves approximately the last 10&nbsp;minutes of the cart’s recording.
            Use this feature in case of an emergency to preserve recent data.
          </Typography>

          <TextField
            label="Record Name"
            fullWidth
            value={recordName}
            onChange={(e) => setRecordName(e.target.value)}
            autoFocus
            disabled={loading}
          />

          {/* Inline status message */}
          {status === "success" && (
            <Typography color="success.main" textAlign="center" fontWeight={500}>
              ✅ Record saved successfully!
            </Typography>
          )}
          {status === "error" && (
            <Typography color="error.main" textAlign="center" fontWeight={500}>
              ❌ Failed to save record. Please try again.
            </Typography>
          )}

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
            <Button onClick={handleClose} disabled={loading}>
              {status === "success" ? "Close" : "Cancel"}
            </Button>
            {status !== "success" && (
              <Button
                variant="contained"
                onClick={handleSave}
                disabled={loading || !recordName.trim()}
              >
                {loading ? "Saving..." : "Save"}
              </Button>
            )}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
